import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import UserService from "services/UserService";
import Dialog from '@mui/material/Dialog';
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import DataTable from "react-data-table-component";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ImageList from "@mui/material/ImageList";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import styled from "styled-components";
import { plan2dItemText } from "variables/MBM/geb";
import {
  item2dlayerData, planitemiconData, item2dpointaggData, item2dvaluetypeData,
  item2diconsizeData, item2dtextsizeData, item2dstepcolorData
} from "variables/MBM/lists/geb";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { getProfilePicture } from "services/ConfigServices";
import { NotificationManager } from "react-notifications";
import CustomSelectWithIcon from "components/Input/CustomSelectWithIcon";
import { definitionData, eosprotocoleData } from "variables/MBM/lists/iotdevices";
import { definitionData as equipmentDefinitionData } from "variables/MBM/lists/equipments";
import { object } from "prop-types";
import ViewEquipmentDialog from "./ViewEquipmentDialog";
import CustomImage from "components/CustomImage/CustomImage";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const Title = styled.div`
text-align: center;
margin-top: 21px;
font-size: 20px;
font-weight: 600;
opacity: 1;
font-family: "Source Sans Pro", sans-serif;
`;
const DataResult = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 15px;
  font-weight: 400;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;
const DataResultLink = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  margin-left: auto;
  text-align: right;
  cursor: pointer;
  text-decoration: underline;
  font-family: "Source Sans Pro", sans-serif;
`;
const DataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.1rem 1rem;
  margin-bottom: 0.6rem;
`;
const DataList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0.6rem 0;
`;
const Data = styled.div`
font-size: 15px;
font-weight: 600;
opacity: 1;
font-family: "Source Sans Pro", sans-serif;
`;
const DataMargin = styled.div`
font-size: 15px;
font-weight: 500;
opacity: 1;
margin-left: 15px;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const infoWindowImg = {
  height: 'auto',
  maxWidth: '98%',
  marginLeft: '1%',
  verticalAlign: 'middle',
  marginBottom: '10px'
}

function ViewIotDialog(props) {
  const classes = useStyles();
  const { currentItem, iots, equipments, plan, currentiot, wpgroup, fullpoints, pointdata, planrawdata, plan1ddata, plan1hdata, workspace } = props;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const [iot, setIot] = useState(currentiot || "");
  const [iotEquipments, setIotEquipments] = useState([]);
  const [equipment, setEquipment] = useState("");
  const { chartIdGroup } = advancedSearchContext;
  const [openEquipment, setOpenEquipment] = useState(false);

  const handleOpenEquipment = (event) => { setOpenEquipment(true); };
  const handleCloseEquipment = (event) => { setOpenEquipment(false); };

  useEffect(() => {
    if (!currentiot) {
      let iottmp = iots.find((i) => i.id == currentItem.parameters?.iot);
      if (iottmp) {
        setIot(iottmp);
      }
    }
  }, []);

  useEffect(() => {
    let iotEquipmentstmp = equipments.filter((e) => (e.connectionproperties?.iotdevice && e.connectionproperties?.iotdevice == iot.id));
    setIotEquipments(iotEquipmentstmp);
  }, [iot]);


  const equipmentscolumns = [
    {
      name: plan2dItemText.name,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name,
    },
    {
      name: plan2dItemText.equipment,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name,
    },
    {
      name: plan2dItemText.type,
      selector: (row) => row.definition,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => equipmentDefinitionData.find((x) => x.id == row?.definition)?.name || ""
    }];

  return (
    <>
      <Title>{currentItem?.parameters?.name || ""}</Title>
      <DialogContent>
        <form className={classes.root}>
          <GridContainer >
            <GridItem xs={12} sm={12} md={6} lg={6}>
              <DataList>
                <DataContainer>
                  <Data>{plan2dItemText.associatediot + " : "}</Data>
                  <DataResult>{iot?.name || ""}</DataResult>
                </DataContainer>
                <DataContainer>
                  <Data>{plan2dItemText.type + " : "}</Data>
                  <DataResult>{definitionData.find((x) => x.id == iot?.definition)?.name || ""}</DataResult>
                </DataContainer>
                <DataContainer>
                  <Data>{plan2dItemText.category + " : "}</Data>
                  <DataResult>{definitionData.find((x) => x.id == iot?.definition)?.category || ""}</DataResult>
                </DataContainer>
                <DataContainer>
                  <Data>{plan2dItemText.deveui + " : "}</Data>
                  <DataResult>{iot?.connectionproperties?.deveui || ""}</DataResult>
                </DataContainer>
                <DataContainer>
                  <Data>{plan2dItemText.eosprotocol + " : "}</Data>
                  <DataResult>{eosprotocoleData.find((x) => x.id == iot?.connectionproperties?.eosprotocol)?.name}</DataResult>
                </DataContainer>
              </DataList>
            </GridItem>
            <GridItem xs={12} sm={12} md={6} lg={6}>
              <div className={"info-window-img"}>
                {iot.otherproperties?.imageCode ? (
                  <CustomImage
                    imageCode={iot.otherproperties.imageCode}
                  />
                ) :
                  (<></>
                  )

                }
              </div>
            </GridItem>
            <GridItem>
              <Data>{plan2dItemText.associatedequipments}</Data>
              <DataTable
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                noDataComponent={<NoData></NoData>}
                noHeader={true}
                columns={equipmentscolumns}
                persistTableHead
                data={iotEquipments}
                striped={true}
                highlightOnHover
                pointerOnHover
                onRowClicked={(row) => {
                  let obj = equipments.find((o) => o.id === row.id);
                  if (obj) {
                    setEquipment(obj);
                    handleOpenEquipment();
                  }
                }
                }
              //theme="solarized"
              />
            </GridItem>
          </GridContainer>
          <Dialog
            onClose={handleCloseEquipment}
            aria-labelledby="edituser-dialog-title"
            maxWidth="false"
            sx={{ '& .MuiPaper-root': { borderRadius: 5, boxShadow: 3 }, }}
            open={openEquipment}
          >
            {/* <CustomDialogTitle id="addMarket-dialog-title" onClose={handleCloseEquipment}>
            {equipment?.name || ""}
          </CustomDialogTitle>
          <DialogContent dividers> */}
            <ViewEquipmentDialog
              currentEquipment={equipment}
              iots={iots}
              equipments={equipments}
              plan={plan}
              fullpoints={fullpoints}
              wpgroup={wpgroup}
              pointdata={pointdata}
              planrawdata={planrawdata}
              plan1ddata={plan1ddata}
              plan1hdata={plan1hdata}
              workspace={workspace}
              fromiot={true}
            />
            {/* </DialogContent>
          <DialogActions /> */}
          </Dialog>
        </form>
      </DialogContent>
    </>
  );
}

export default ViewIotDialog;
